export var RevalidationStatus;
(function (RevalidationStatus) {
    RevalidationStatus["Valid"] = "VALID";
    RevalidationStatus["Invalid"] = "INVALID";
})(RevalidationStatus || (RevalidationStatus = {}));
